<script>
  import contratoServico from '../servico';
  import { alert } from 'vue-strap';

  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  
  export default {
    components: { alert, Cabecalho},
    data() {
      return {
        carregando: true,
        contrato: {},
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar() {
        this.carregando = true;
        
        return contratoServico
          .obterPorId(this.$route.params.id)
          .then(contrato => {
            this.carregando = false;

            this.contrato = contrato;
          });
      },   
      retornaTipo(tipo) {
        switch (tipo) {
          case 1: return "Bolsa";
            break;
          case 2: return "RPA";
            break;
          case 3: return "Estágio";
            break;
          case 5: return "Adicional variável";
            break;
          default:
            return "Contrato";
            break;
        }
      },
      retornaTipoTitulo(tipo) {
        switch (tipo) {
          case 1: return "Bolsista";
            break;
          case 2: return "Autonômo";
            break;
          case 3: return "Estagiário";
            break;
          default:
            return "Contratada";
            break;
        }
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Contrato - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.botaoAcaoMostrar = true;

      this.$root.botaoRetrocederMostrar = true;
      this.$root.botaoRetrocederRota = 'contrato.liberados';

      this.$events.on('botaoAcao', function () {
        window.print();
      });

      this.carregar(); 
    },
  }
</script>

<style scoped>
  .liberado {
    font-size: 1.35em;
    color: #1d9d74;
    margin-right: 3px;
  }

  .naoLiberado {
    font-size: 1.35em;
    color: #f5f5f5;
    margin-right: 3px;
  }
</style>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <p v-show="carregando" class="text-center">
              <i class='fa fa-spinner fa-pulse'></i> Carregando...
            </p>

            <div v-if="!carregando">
              <cabecalho :titulo="'Contrato - Relatório'"></cabecalho>

              <h3 class="m-t-none m-b">Contrato: {{ contrato.codigoInterno }} | Sol. web: {{ contrato.idSolicitacaoWEB}}</h3>

              <div class="hr-line-dashed margin-top-5"></div>

              <div class="row">
                <dl class="col-xs-4">
                  <dt>Nome</dt>
                  <dd>{{ contrato.nomeContrato }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Código interno</dt>
                  <dd>{{ contrato.codigoInterno }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Código externo</dt>
                  <dd>{{ contrato.codigoExterno }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Tipo</dt>
                  <dd>{{ retornaTipo(contrato.tipoContrato) }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Valor contrato</dt>
                  <dd>{{ contrato.valor | formatarNumero }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-3">
                  <dt>Tipo de contrato</dt>
                  <dd>{{ contrato.tipoContratoObjeto ? contrato.tipoContratoObjeto.nome : '---' }}</dd>
                </dl>
                <dl class="col-xs-3">
                  <dt>Subtipo de contrato</dt>
                  <dd>{{ contrato.subTipoContratoObjeto ? contrato.subTipoContratoObjeto.nome : '---' }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Data assinatura</dt>
                  <dd>{{ contrato.dataAssinatura | formatarNumeroEmData }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Vigência início</dt>
                  <dd>{{ contrato.vigenciaContrato | formatarNumeroEmData }}</dd>
                </dl>
                <dl class="col-xs-2">
                  <dt>Vigência fim</dt>
                  <dd>{{ contrato.vigenciaContratoFim | formatarNumeroEmData }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-12">
                  <dt>Observação</dt>
                  <dd>{{ contrato.descricao }}</dd>
                </dl>
              </div>

              <div class="row">
                <dl class="col-xs-12">
                  <dt>{{ retornaTipoTitulo(contrato.tipoContrato) }}</dt>
                  <dd>{{ contrato.contratada ? contrato.contratada.nomePessoaFisicaJuridica + ' - ' + contrato.contratada.cpfCnpj : '---'  }}</dd>
                </dl>
              </div>

              <div class="hr-line-dashed margin-top-5"></div>          

              <div class="bs-callout bs-callout-info no-margin-top" v-for="(projetoContrato, index) in contrato.projetoContratos">
                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Projeto</dt>
                    <dd>{{ projetoContrato.projeto ? projetoContrato.projeto.nomeProjeto : '---' }}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/contrato/componentes/RelatorioLiberados.vue